import useSWR from "swr";
import { swrOptionsNoRetry } from "../../utils/hooks/swr/constants";
import { useSite } from "./useSite";

interface UseFetchStaticJsonParams {
  file?: string;
  files?: string[];
  isLocal?: boolean;
  folder?: string;
}

const useFetchStaticJson = ({ file, files = [], isLocal = true, folder = "" }: UseFetchStaticJsonParams) => {
  const { mySite } = useSite();

  const fetchRemoteFeed = async ({ file, files, isLocal, folder }) => {
    if (!files || files.length === 0) {
      const path = isLocal ? `${process.env.PUBLIC_URL}/statics${folder}` : `${mySite.assetsJsonUrl}${folder}`;
      return await fetch(`${path}/${file}`)
        .then((response) => {
          return response.json();
        })
        .then((resp) => {
          return resp;
        });
    } else {
      const JSONs = files.map((file: string) => {
        return {
          file,
          URL: isLocal
            ? `${process.env.PUBLIC_URL}/statics${folder}/${file}`
            : `${mySite.assetsJsonUrl}${folder}/${file}`,
        };
      });
      const JSONResp: Record<string, any> = {};
      await Promise.all(
        JSONs.map(async (jsonData) => {
          return fetch(jsonData.URL)
            .then((r) => {
              return r.json();
            })
            .then((parsedResp) => {
              const fileNameWithoutExtension = jsonData.file.split(".")[0];
              JSONResp[`${fileNameWithoutExtension}`] = parsedResp;
            });
        })
      );
      return JSONResp;
    }
  };

  const payload = {
    isLocal,
    file,
    files,
    folder,
  };
  const isFileRequestValid = file || (files && files.length > 0);

  return useSWR(isFileRequestValid ? payload : null, fetchRemoteFeed, swrOptionsNoRetry);
};

export default useFetchStaticJson;
